import BookingDetailsSlideOver from "../../routes/slideovers/BookingDetailsSlideOver";
import CalendarViewFiltersSlideover from "../../routes/slideovers/CalendarViewFilters";
import InvoiceDetailsSlideover from "../../routes/slideovers/DiscountDetailsSlideover";
import MembershipDetailsSlideover from "../../routes/slideovers/MembershipDetailsSlideover";

const RootContainerSlideovers = () => {
  return (
    <>
      <MembershipDetailsSlideover />
      <InvoiceDetailsSlideover />
      <CalendarViewFiltersSlideover />
      <BookingDetailsSlideOver />
    </>
  );
};

export default RootContainerSlideovers;
